export type ShareVariation = {
    id: string;
    format: string;
    label: string;
    theme: string;
    responsive: boolean;
    scale?: number;
    x?: number;
    y?: number;
    textColor?: string;
    urbaniaLogoSize: number;
    labelBackground?: string;
    authorPrefix?: string;
    withCoverImage?: boolean;
    withoutLabel?: boolean;
    withUrbaniaLogo?: boolean;
    withoutSurtitle?: boolean;
    withoutAuthorBox?: boolean;
    withoutDate?: boolean;
    withoutAuthorImage?: boolean;
    textShadow?: number;
};

export type ShareFormat = {
    id: string;
    label: string;
    width: number;
    height: number;
};

export const formats: ShareFormat[] = [
    {
        id: 'micromag',
        label: 'Micromag',
        width: 1080,
        height: 1600,
    },
    {
        id: 'instagram',
        label: 'Instagram',
        width: 1080,
        height: 1350,
    },
    {
        id: 'facebook',
        label: 'Facebook',
        width: 1200,
        height: 800,
    },
    {
        id: 'story_ad',
        label: 'Publicité (Story)',
        width: 1080,
        height: 1920,
    },
];

const variationsCreator: ((format: ShareFormat) => ShareVariation)[] = [
    ({ id, width, height }) =>
        id !== 'micromag'
            ? {
                  id: `over-${id}`,
                  format: id,
                  label: 'Texte sur l’image',
                  theme: 'over-bottom-left',
                  responsive: true,
                  scale: width > height ? 1.5 : 2.8,
                  withoutSurtitle: true,
                  urbaniaLogoSize: width > height ? 0.2 : 0.5,
                  // size: 'big',
              }
            : null,
    ({ id, width, height }) =>
        id !== 'micromag'
            ? {
                  id: `box-${id}`,
                  format: id,
                  label: 'Texte en dessous de l’image',
                  theme: 'box-bottom-left',
                  responsive: true,
                  scale: width > height ? 1.5 : 2.5,
                  urbaniaLogoSize: width > height ? 0.2 : 0.5,
                  labelBackground: '#fff',
                  // size: 'big',
              }
            : null,
    ({ id, width, height }) =>
        id === 'micromag'
            ? {
                  id: `micromag-${id}`,
                  format: id,
                  label: 'Couverture du micromag',
                  theme: 'box-bottom-left',
                  responsive: true,
                  scale: width > height ? 1.5 : 2.5,
                  urbaniaLogoSize: width > height ? 0.2 : 0.5,
                  labelBackground: '#fff',
                  withCoverImage: true,
                  withoutLabel: true,
                  withUrbaniaLogo: false,
                  // size: 'big',
              }
            : null,
];

export const getDefaultProps = (document: FullDocument) => {
    const { type = 'article' } = document || {};
    return {
        authorPrefix:
            type === 'video' ? 'Une vidéo de' : type === 'podcast' ? 'Un balado de' : 'Un texte de',
        theme: 'over-bottom-left',
        withoutAuthorBox: true,
        withoutDate: true,
        withoutAuthorImage: true,
        withUrbaniaLogo: true,
        textShadow: 0,
    };
};

export const variations: ShareVariation[] = formats.reduce(
    (allVariations, format) => [
        ...allVariations,
        ...variationsCreator.map((creator) => creator(format)).filter((it) => it !== null),
    ],
    [],
);

export const utmSources = [
    {
        label: 'Journaliste',
        value: 'journaliste',
    },
    {
        label: 'Employés URBANIA',
        value: 'employes_urbania',
    },
    {
        label: 'RP',
        value: 'rp',
    },
    {
        label: 'Contact Direct',
        value: 'contact_direct',
    },
    {
        label: 'Partenariat Rémunéré',
        value: 'partenariat_remunere',
    },
    {
        label: 'ManyChat',
        value: 'manychat',
    },
];

export const utmMediums = [
    {
        label: 'Partage',
        value: 'partage',
    },
];
